import {
  Typography as MuiTypography,
  Grid as MuiGrid,
  CircularProgress as MuiCircularProgress,
} from "@mui/material";
import { Info as MuiInfoIcon } from "@mui/icons-material";
import { Trans } from "react-i18next";
import Export from "app/shared/UI/Export";
import { GET_IMPORTS_URL_BASE } from "app/shared/constants";
import { headerStyles, multiLineCell } from "app/shared/UI/sharedStyles";

const mapStatus = (originalStatus) => {
  const lowercaseStatus = originalStatus.toLowerCase();
  return lowercaseStatus[0].toUpperCase() + lowercaseStatus.substring(1);
};

export const defaultTableColumnHeaders = (t, displayImportFailureDialog) => [
  {
    field: "index",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnIndex" />
      </MuiTypography>
    ),
    width: 50,
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    sortable: false,
    flex: 1,
  },
  {
    field: "filename",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnFileName" />
      </MuiTypography>
    ),
    renderCell: ({ row }) => (
      <MuiTypography sx={multiLineCell}>
        <Export
          displayName={row.filename}
          exportURL={`${GET_IMPORTS_URL_BASE}/${row.id}/uploaded-file`}
        />
        <MuiGrid size={2}>
          {row.status === "UPLOADED" && <MuiCircularProgress size={20} />}
        </MuiGrid>
      </MuiTypography>
    ),
    minWidth: 400,
    sortable: false,
    flex: 1,
  },
  {
    field: "irbNumber",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnIRBNumber" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    sortable: false,
    minWidth: 100,
    flex: 1,
  },
  {
    field: "source",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsCohortHistory.cohortSourceType" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>
        {t("ProspectSourceType." + value)}
      </MuiTypography>
    ),
    minWidth: 200,
    sortable: false,
    flex: 1,
  },
  {
    field: "status",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnStatus" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{mapStatus(value)}</MuiTypography>
    ),
    sortable: false,
    minWidth: 250,
    flex: 1,
  },
  {
    field: "imported",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnImported" />
      </MuiTypography>
    ),
    renderCell: ({ row }) => (
      <MuiTypography sx={multiLineCell}>
        {row.summary ? row.summary.rows - row.summary.errors : 0}
      </MuiTypography>
    ),
    sortable: false,
    minWidth: 150,
    flex: 1,
  },
  {
    field: "failed",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnFailed" />
      </MuiTypography>
    ),
    renderCell: ({ id, row, api }) => {
      const index = api.getRowIndexRelativeToVisibleRows(id);
      return (
        <MuiTypography sx={multiLineCell}>
          {row.summary.errors}
          {row.summary.report && row.summary.report.length > 0 && (
            <MuiInfoIcon
              color="primary"
              onClick={() =>
                displayImportFailureDialog(index, row.summary.report)
              }
              fontSize="small"
            />
          )}
        </MuiTypography>
      );
    },
    sortable: false,
    minWidth: 170,
    flex: 1,
  },
  {
    field: "importedBy",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnImportedBy" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    sortable: false,
    flex: 1,
    minWidth: 170,
  },
  {
    field: "timestamp",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ImportProspectsPage.tableColumnImportedDate" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>
        {new Date(value).toLocaleString()}
      </MuiTypography>
    ),
    sortable: false,
    flex: 1,
    minWidth: 200,
  },
];
